export default __webpack_public_path__ + "static/media/480_portfolio02-es-mobile.a81d4afd.png";